import {makeBFFApiUrl} from 'main/factories/http';
import {makeAuthorizeHttpClientDecorator} from 'main/factories/decorators';
import {PatchHealthConfirmAppointments} from 'domain/usecases';
import {RemotePatchHealthConfirmAppointments} from 'data/usecases';
import {BookingFlowEndPoints} from 'main/factories/usecases/endpoints';

export const makePatchHealthConfirmAppointments = (): PatchHealthConfirmAppointments =>
	new RemotePatchHealthConfirmAppointments(
		makeBFFApiUrl(BookingFlowEndPoints.healthScheduledAppointments),
		makeAuthorizeHttpClientDecorator(),
	);
